import { CSSProperties, MouseEvent } from 'react';
import { isFunction } from '@Utils/Micro';
import { blue500 } from '@Utils/Colors';
// --------------------------------------------------------------------------------------------
interface CheckboxProps {
    key?: string | number;
    value: boolean;
    checkedIcon?: string;
    uncheckedIcon?: string;
    className?: string;
    style?: CSSProperties;
    onClick?: (ev: MouseEvent) => void;
}
// --------------------------------------------------------------------------------------------
export default function Checkbox(props: CheckboxProps) {
    let icon = props.uncheckedIcon ?? 'far fa-square';
    if (props.value)
        icon = props.checkedIcon ?? 'fas fa-check-square';

    return <div
        key={props.key}
        className={`${icon} ${props.className ?? ''}`}
        style={{
            fontSize: 18,
            color: blue500,
            pointerEvents: props.onClick ? 'auto' : 'none',
            cursor: props.onClick ? 'pointer' : 'none',
            ...props.style
        }}
        onClick={ev => {
            if (isFunction(props.onClick))
                props.onClick(ev);
        }} />
}
// --------------------------------------------------------------------------------------------